module.exports = __webpack_public_path__ + "img/Bosnia-&-Herzegovina.3c33de9b.png";